import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import { UserAccessRightsGuard } from '../../role/user-role/user-access-rights.guard'
import { AccessRights } from '../../role/user-role/user-role'
import { SerieProposalSeriesTabComponent } from './series-tab/show.component'
import { SerieProposalMessagesTabComponent } from './messages-tab/messages-tab.component'
import { SerieProposalGeneralTabComponent } from './general-tab/show.component'
import { SerieProposalIndexComponent } from './index/index.component'
import { SerieProposalSalesTabComponent } from './sales-tab/show.component'
import { SerieProposalShowComponent } from './show/show.component'

const routes: Routes = [
  {
    path: '',
    component: SerieProposalIndexComponent,
    pathMatch: 'full'
  },
  {
    path: ':serieProposalId',
    component: SerieProposalShowComponent,
    canActivate: [UserAccessRightsGuard],
    data: { accessRights: [AccessRights.Bookings_read] },
    children: [
      {
        path: '',
        component: SerieProposalGeneralTabComponent,
        pathMatch: 'full'
      },
      { path: 'series', component: SerieProposalSeriesTabComponent },
      {
        path: 'messages',
        component: SerieProposalMessagesTabComponent
      },
      {
        path: 'sales',
        component: SerieProposalSalesTabComponent
      }
    ]
  }
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SerieProposalRoutingModule {}
